import { ga, amplitude } from 'js/analytics/adapters'
import { baseWebEventProps } from 'js/analytics/standardizedProps'
import { funnelStepNames } from './funnelStepNames'

export const trackAccountFlowStep = ({
  step,
  scenario = '',
  couponCode = '',
  planDuration = null,
  entryPoint = '',
}) => {
  const properties = {
    step,
    scenario,
    coupon_code: couponCode,
    plan_duration: planDuration,
    entry_point: entryPoint,
  }
  ga.track('account_flow_step', properties)
  // Emit user_start_onboarding once per step.
  // trackSignUpFunnelStep no longer emits it, so this is the single source.
  // funnel_step uses a proper mapped name (falls back to the raw step so it is
  // never blank); funnel_type defaults to 'onboarding' when no scenario is given.
  amplitude.track('user_start_onboarding', {
    ...baseWebEventProps(),
    action_name: 'start',
    action_type: 'active',
    funnel_step: funnelStepNames[step] ?? step,
    funnel_type: scenario || 'onboarding',
    ...(entryPoint ? { event_source: entryPoint } : {}),
    coupon: couponCode,
  })
}
